module.exports = __webpack_public_path__ + "assets/defaultWhite-2322d0.svg";